import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material";
import BLAKProcessPharmaciesList from "./DialogTable";
import BLAKProcessPharmaciesListArchive from "./ArchiveDialogTable";

export default function ExamProcessDialog(props) {
  const theme = useTheme();

  const handleClose = () => {
    props.function();
    props.setOpen();
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen()} maxWidth={1}>
      <DialogTitle>{"Apothekenliste"}</DialogTitle>
      <DialogContent>
        {props.archive ? (
          <BLAKProcessPharmaciesListArchive processID={props.id} />
        ) : (
          <BLAKProcessPharmaciesList processID={props.id} />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          sx={{ color: theme.palette.mode === "dark" ? "#c4c4c4" : "#666666" }}
        >
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
